import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import UserProfileSidebar from "../Components/UserProfileSidebar";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { patientOrdersapi } from "../network/Network";
import moment from "moment";
import Norecord from "../Components/Norecord";

const UserMyOrder = () => {
	const token = useSelector((state) => state?.Auth?.token);
	const [patientorder, setPatientorder] = useState([]);
	const orders = [
		{
			orderId: "Order ID: 0123546",
			date: "29-Jun-23",
			qty: "05",
			status: "Completed",
		},
		{
			orderId: "Order ID: 0123546",
			date: "30-Jun-23",
			qty: "10",
			status: "Pending",
		},
		{
			orderId: "Order ID: 0123546",
			date: "01-Jul-23",
			qty: "15",
			status: "Shipped",
		},
	];
	// Get My Orders Api
	useEffect(() => {
		patientOrdersapi(token).then((res) => {
			setPatientorder(res?.data);
		});
	}, []);
	//   ===============

	return (
		<>
			<Header />
			<PageHeader pagename="User Profile" />
			<section className="main-sidebar user-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<UserProfileSidebar />
						</div>
						<div className="col-lg-8">
							<div className="main-profile-content radius-20 p-4">
								<div className="main-headind d-flex align-items-center 	gap-3 mb-3">
									<div className="edit-btn back">
										<div className="nav-anchor">
											<i className="fa-solid fa-arrow-left"></i>
										</div>
									</div>
									<h5 className="main-heading level-6 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s ">
										My Orders
									</h5>
								</div>
								{patientorder?.length > 0 ? (
									<>
										<div className="wrapper-table-main">
											<div className="row">
												<div className="col-lg-12 table-responsive">
													<table className="table  ">
														<thead>
															<tr>
																<th className="th">Order ID</th>
																<th className="th">Date</th>
																<th className="th">Status</th>
																<th className="th">Detail</th>
															</tr>
														</thead>
														<tbody>
															{patientorder?.map((order, pindex) => {
																return (
																	<>
																		<tr key={pindex}>
																			<td className="td" data-label="Order ID">
																				{order?.id}
																			</td>
																			<td className="td" data-label="Date">
																				{moment(order?.created_at).format(
																					"MMMM Do YYYY, h:mm a",
																				)}{" "}
																			</td>
																			<td
																				style={{
																					textTransform: "capitalize",
																				}}
																				className="td"
																				data-label="Status"
																			>
																				{order?.status}
																			</td>

																			<td className="td" data-label="Status">
																				<Link
																					className="dark-color text-decoration-none"
																					to={`/my-order-detail/${order?.id}`}
																				>
																					View Detail
																				</Link>
																			</td>
																		</tr>
																	</>
																);
															})}
														</tbody>
													</table>
												</div>
											</div>
										</div>
									</>
								) : (
									<Norecord />
								)}
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default UserMyOrder;
